// extracted by mini-css-extract-plugin
var _1 = "TableSwitchCell-modulecontainer__V39AF";
var _2 = "TableSwitchCell-moduleswitch__mB2CE";
export { _1 as "container", _2 as "switch" }
